import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useRepairDeleteMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const repairDeleteModal: any = {};

export const RepairDeleteModal = () => {
  const { mutate } = useRepairDeleteMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    repairDeleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(repairDeleteModal).forEach((key) => {
      if (key !== 'open') delete repairDeleteModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: repairDeleteModal.id },
      {
        onSuccess: () => {
          setOpen(false);
          repairDeleteModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.REPAIR.ERROR.NOT_DELETED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'repair-delete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.repairDeleteTitle')}: {repairDeleteModal.number}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
